import { render, staticRenderFns } from "./districtsMain.vue?vue&type=template&id=45151233&scoped=true&"
import script from "./districtsMain.vue?vue&type=script&lang=js&"
export * from "./districtsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45151233",
  null
  
)

export default component.exports